/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260121    
*/
'use strict';


import {
    getTableRows
} from './ctssHtml.js';
import {
    getPromise,
} from './ctssJQuery.js';
import {
    appDebugMode,
    getAppToken,
    setMenu
} from './snSite.js';

const token = getAppToken();

const getEventParticipantsDataAsync = async (eventID) =>
    await getPromise({ url: `Events/${token.CG}/${eventID}/Participants` });

const getEventParticipantRow = (params) => {
    return '<tr>' +
        '<td class="col-md-3">' + params.data.name + '</td>' +
        '<td class="col-md-3">' + params.data.email + '</td>' +
        '<td class="col-md-2">' + params.data.phone + '</td>' +
        '<td class="col-md-2">' + params.data.attendeesCnt + '</td>' +
        '<td class="col-md-2">' + params.data.volunteersCnt + '</td>' +
        '</tr>';
}

const getEventRow = (params) => {
    const attendees = params.data.maxAttendees === 0
        ? params.data.totalAttendees
        : `${params.data.totalAttendees}/${params.data.maxAttendees}`;
    const volunteers = params.data.volunteersNeeded === 0
        ? params.data.totalVolunteers
        : `${params.data.totalVolunteers}/${params.data.volunteersNeeded}`;
    return '<tr>' +
        '<td class="col-md-6">' + params.data.title + '</td>' +
        '<td class="col-md-2">' + attendees + '</td>' +
        '<td class="col-md-2">' + volunteers + '</td>' +
        '<td class="col-md-2 text-right">' +
        '<span class="fa fa-users mRight10" title="View participants..." data-toggle="modal" ' +
        'data-target="#eventParticipantsDlg" data-key="' + params.data.id + '" ' +
        'data-title="' + params.data.title + '"></span ></td >' +
        '</tr>';
}

const getEventsAsync = async () => {
    const isAdmin = token.IsAdmin == 'True' ? true : false;
    const url = isAdmin
        ? `Events/${token.CG}/ScheduledMenu/${isAdmin}`
        : `Events/${token.CG}/ScheduledMenu/false?mg=${token.sub}`;

    return await getPromise({ url: url });
}

const initEventParticipantsDlg = () => {
    $('#eventParticipantsDlg').on('show.bs.modal', async (e) => {
        const key = e.relatedTarget.dataset.key,
            title = e.relatedTarget.dataset.title;
        $('#eventParticipantsDlgLbl').text(`Viewing ${title} attendees...`);
        try {
            const data = await getEventParticipantsDataAsync(key);
            getTableRows({
                arr: data, fnGetRow: getEventParticipantRow, gridNm: 'gridEventParticipants'
            });
        }
        catch (error) { }
    });
}

const initAsync = async () => {
    setMenu();
    try {
        const events = await getEventsAsync();
        getTableRows({
            arr: events, fnGetRow: getEventRow, gridNm: 'gridEvents'
        });
    }
    catch (error) { }
    initEventParticipantsDlg();
};

window.snScheduleEventAttendance = {
    initAsync
};
